exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fabric-category[data-v-0f682ad2] {\n  width: 200px;\n}\n.fabric-number[data-v-0f682ad2] {\n  width: 300px;\n}\n", ""]);

// exports
